import { ACTION_AUTHEN_TOKEN_EXPIRE } from ".";

export const logoutRequest = () => ({
    type: ACTION_AUTHEN_TOKEN_EXPIRE
})

export const logout = () => {
    return dispatch => {
        dispatch(logoutRequest())
    }
}